import config from "config";
import {
  APP_FILTER_TYPES,
  CASCADE_NAMES,
  FACET_PATH_DELIMITER,
} from "constants/filter";
import { CHANGE_TYPES } from "constants/search";
import { QUERY_PARAMS } from "constants/URL";
import { hasSearchParam } from "utils/url";
import { getDataPointForFilter } from "utils/filter";

export const TYPE = {
  TARGET: "target",
  SEARCH: "search",
};

export const DIMENSION = {
  USER_TERM: "sucheingabe",
  SEARCH_TYPE: "suchtyp",
};

export const ACTIONS = {
  QUERY_CHANGE: "queryChange",
  FILTER_CHANGE: "filterChange",
  OTHER: "other",
};

const TrackingLogger = {
  _logSearchTrack(data) {
    const filterData = data.sfilter || ["no Filters set"];
    const searchData = data.search && JSON.stringify(data.search);
    const jsonData = data && JSON.stringify(data);

    console.group("%c Filters:", "font-weight: bold");
    console.table(filterData);
    console.groupEnd();

    console.group("%c Search:", "font-weight: bold");
    console.table(searchData);
    console.groupEnd();

    console.group("%c Tracking Data to send:", "font-weight: bold");
    console.log(jsonData);
    console.groupEnd();
  },
  track(data) {
    const headerCSS = ["color: #0094AA; font-weight: bold;"];

    console.groupCollapsed("%c Tracking Data", ...headerCSS);
    if (data.search !== undefined || data.sfilter !== undefined) {
      this._logSearchTrack(data);
    } else {
      console.table(data);
    }
    console.groupEnd();
  },
};

class Tracker {
  constructor() {
    this.tracking = config.appEnv === "dev" ? TrackingLogger : config.tracking;
  }

  _aggregateData(filters, count) {
    const data = Object.keys(filters).reduce(
      (result, filterKey) => {
        const filter = filters[filterKey];
        if (filter.filterType && filter.values && filter.values.length) {
          switch (filter.filterType) {
            case APP_FILTER_TYPES.QUERY: {
              result.search = [filter.values[0], count];
              break;
            }
            case APP_FILTER_TYPES.CASCADE: {
              const splitFilterValues =
                filter.values[0].split(FACET_PATH_DELIMITER);
              const filterCascadeLevels = CASCADE_NAMES[filterKey];
              const filterEntries = splitFilterValues.map((value, index) => [
                filterCascadeLevels[index],
                value,
              ]);

              result.sfilter = result.sfilter
                ? [...result.sfilter, ...filterEntries]
                : [...filterEntries];
              break;
            }
            default: {
              const filterEntries = this._resolveOptionFilterEntries(
                filterKey,
                filter,
              );
              result.sfilter = result.sfilter
                ? [...result.sfilter, ...filterEntries]
                : [...filterEntries];
            }
          }

          return result;
        }

        return result;
      },
      { search: [] },
    );

    return data;
  }

  /**
   * Send tracking data to cv-tracking script
   *
   * @param {Array} trackingData - Array with tracking data, which is send to cv-tracking script
   * @param {Object} options - Object with options for cv-tracking script
   */
  _targetTrack({ trackingData, options }) {
    this.tracking.track(
      {
        Target: trackingData,
      },
      options,
    );
  }

  _trackSearchResult(state, action, dimensions) {
    const trackingData = this._aggregateData(
      state.filters,
      state.result.totalCount,
    );
    const searchTypeDimension = action
      ? { [DIMENSION.SEARCH_TYPE]: [[action]] }
      : {};

    if (this.tracking && trackingData) {
      this.tracking.track({
        ...trackingData,
        ...searchTypeDimension,
        ...dimensions,
      });
    }
  }

  _resolveOptionFilterEntries(filterKey, filter) {
    return filter.values.map((value) => {
      const filterData = getDataPointForFilter(value, filter);

      return [
        filterKey,
        filterData && filterData.label ? filterData.label : value,
      ];
    });
  }

  getActionFromChangeType(changeType) {
    if (changeType === CHANGE_TYPES.FILTER) {
      return ACTIONS.FILTER_CHANGE;
    }
    if (
      changeType === CHANGE_TYPES.QUERY ||
      (changeType === CHANGE_TYPES.INITIALIZE &&
        hasSearchParam(QUERY_PARAMS.IS_USER_SEARCH))
    ) {
      return ACTIONS.QUERY_CHANGE;
    }

    return ACTIONS.OTHER;
  }

  track(type, data) {
    if (type === TYPE.SEARCH) {
      this._trackSearchResult(...data);
      return;
    }
    if (type === TYPE.TARGET) {
      this._targetTrack(data);
    }
  }
}

export default new Tracker();
